import React, { PropTypes } from "react";
import { FormattedMessage, intlShape } from "react-intl";
import { connect } from "react-redux";
import { Field, formValueSelector } from "redux-form";
import { MessageBox } from "../../../../../../common";
import { SelectInput } from "../../../../../../common/form";
import {
  EXPORTED_TO_ACOMBA,
  GENERATED,
  TEMPLATE,
} from "../../../invoices/enums/invoiceStatuses";
import BillingPeriodField from "../BillingPeriodField";
import userHasAccess from "../../../../../../../utils/userHasAccess";
import { PLAN_ADMINISTRATOR } from "../../../../../../../utils/Roles";
import payrollReportFrequencyTypes from "../../enums/payrollReportFrequencyTypes";

const getFrequencyOptions = (translationFn) =>
  payrollReportFrequencyTypes.map((type) => ({
    value: type.value,
    text: translationFn({ id: type.key }),
  }));


const getYearOptions = (billingPeriods) => {
  const dates = billingPeriods.map((bp) => [bp.startDate, bp.endDate]).flat();
  const years = dates.map((date) => new Date(date).getFullYear().toString());
  const uniqueYears = [...new Set(years)];
  return uniqueYears.map((year) => ({
    value: year,
    text: year,
  }));
};

const getInvoicedBillingPeriods = (billingPeriods) => {
  return billingPeriods.filter(
    (billingPeriod) =>
      billingPeriod.invoice &&
      billingPeriod.invoice.invoiceType != TEMPLATE.value &&
      (billingPeriod.invoice.invoiceStatusType == GENERATED.value ||
        billingPeriod.invoice.invoiceStatusType == EXPORTED_TO_ACOMBA.value
      )
  );
};

const PayrollDeductionForm = (
  { isAnnual, billingPeriods, handleReportFormatChange, handleBillingPeriodChange, handleYearChange },
  { intl: { formatMessage } }
) => {
  const billingPeriodsInvoiced = getInvoicedBillingPeriods(billingPeriods);
  const isPlanAdministrator = userHasAccess(PLAN_ADMINISTRATOR, true);
  return (
    <div>
      <Field
        id="payrollFrequency"
        name="payrollFrequency"
        component={SelectInput}
        sortOptions={false}
        options={getFrequencyOptions(formatMessage)}
        addBlankOption={true}
        label={
          <FormattedMessage id="clients.client.reports.payrollDeductions.form.format" />
        }
        onChange={handleReportFormatChange}
      />
      {isAnnual ? (
        <Field
          id="year"
          name="year"
          component={SelectInput}
          options={getYearOptions(billingPeriods)}
          reverseSortOptions={true}
          label={
            <FormattedMessage id="clients.client.reports.payrollDeductions.form.year" />
          }
          onChange={handleYearChange}
        />
      ) : (
        (Array.isArray(billingPeriodsInvoiced) && billingPeriodsInvoiced.length > 0 ? <BillingPeriodField
          id="billingPeriodId"
          name="billingPeriodId"
          billingPeriods={billingPeriodsInvoiced}
          onChange={handleBillingPeriodChange}
        /> : <MessageBox className="alert-warning form-group">
          {isPlanAdministrator ?
            <FormattedMessage id="clients.client.reports.payrollDeductions.validBilingPeriodsWarningPA" /> :
            <FormattedMessage id="clients.client.reports.payrollDeductions.validBilingPeriodsWarning" />}
        </MessageBox>)
      )}
    </div>
  );
};

PayrollDeductionForm.propTypes = {
  billingPeriods: PropTypes.array.isRequired,
  clientId: PropTypes.number.isRequired,
  dataActions: PropTypes.object,
  invoices: PropTypes.array,
  isAnnual: PropTypes.bool,
  handleReportFormatChange: PropTypes.func,
  handleBillingPeriodChange: PropTypes.func,
  handleYearChange: PropTypes.func,
};
PayrollDeductionForm.contextTypes = {
  intl: intlShape,
};

const selector = formValueSelector("clientReportsForm");
const mapStateToProps = (state) => {
  const payrollFrequency = selector(state, "payrollFrequency");
  const annualTypes = payrollReportFrequencyTypes
    .filter((type) => type.value.includes("ANNUAL"))
    .map((type) => type.value);
  return {
    isAnnual: annualTypes.includes(payrollFrequency),
  };
};

export default connect(mapStateToProps)(PayrollDeductionForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/payrollDeductions/PayrollDeductionsForm.js